import React, { useState } from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import principalImg from "../assets/archive/principal.jpg";
import presidentImg from "../assets/archive/president.jpg";
import managerImg from "../assets/archive/manager.jpg";

const Archive = () => {
  const [open, setOpen] =
    useState(false);

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO */}
      <section className="bg-[#0A3470] py-16 text-center">

        <h1 className="text-5xl md:text-6xl font-bold text-white uppercase">

          Archives

        </h1>

        <p className="text-white/80 mt-4 text-lg">

          History & Administration

        </p>

        <div className="w-28 h-1 bg-[#D4A017] mx-auto rounded-full mt-5"></div>

      </section>

      {/* CONTENT */}
      <section className="bg-[#f5f1df] py-16">

        <div className="max-w-6xl mx-auto px-5">

          <div className="bg-[#faf7ea] border border-[#e4dcc0] rounded-3xl shadow-lg p-8 md:p-12">

            {/* HISTORY */}
            <div className="text-center">

              <h2 className="text-3xl md:text-4xl font-bold text-[#0A3470]">

                History Of School

              </h2>

              <div className="w-24 h-1 bg-[#D4A017] mx-auto rounded-full mt-4 mb-8"></div>

            </div>

            <div className="space-y-6 text-[17px] leading-9 text-[#4b4b4b]">

              <p>
                St. Joseph’s School was founded in 1993. It is located at
                Maharajganj, Uttar Pradesh. It has about 2 acre 12 decimal of
                land. It is run by Miss Jancy Memorial Welfare Society (A
                Christian minority society).
              </p>

              <p>
                The strength of the school is increasing day by day. The school
                has grown very rapidly and has earned the name of being one of
                the most prestigious schools at Maharajganj, U.P. The school is
                committed to personalized teaching.
              </p>

              <p>
                The School aims to give the students a balanced variety of
                educational, social and cultural experiences to prepare them for
                life itself. Children are admitted as day scholars. The school
                has classes from I to XII.
              </p>

              <p>
                The qualified and experienced staff believes in challenging
                their own abilities as well as the abilities of their students.
                They are always in search of new ideas adaptable to the demands
                of changing times.
              </p>

              <p>
                The medium of instruction is English and the Second language
                taught is Hindi. The Third Language offered is Sanskrit. The
                School is secular in character.
              </p>

            </div>

            {/* AIM */}
            <div className="mt-16 text-center">

              <h2 className="text-3xl md:text-4xl font-bold text-[#0A3470]">

                School Aim

              </h2>

              <div className="w-24 h-1 bg-[#D4A017] mx-auto rounded-full mt-4 mb-8"></div>

              <p className="text-[17px] leading-9 text-[#4b4b4b] max-w-5xl mx-auto">

                The School aims at developing the total personality of the child
                to make him a better citizen of tomorrow, by imbibing in him
                the qualities of leadership, reverence for Indian culture,
                regards for elders and respect for the noble ideals and norms
                of society.

              </p>

            </div>

            {/* ADMINISTRATION */}
            <div className="mt-20">

              <div className="text-center">

                <h2 className="text-3xl md:text-4xl font-bold text-[#0A3470]">

                  Administration

                </h2>

                <div className="w-24 h-1 bg-[#D4A017] mx-auto rounded-full mt-4 mb-12"></div>

              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

                {/* PRINCIPAL */}
                <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-[#e8e8e8] text-center">

                  <div className="bg-[#0A3470] py-4">

                    <h3 className="text-2xl font-bold text-white">

                      Principal

                    </h3>

                  </div>

                  <img
                    src={principalImg}
                    alt="Principal"
                    className="w-full h-[320px] object-cover"
                  />

                  <div className="p-5">

                    <h4 className="text-xl font-bold text-[#0A3470]">

                      Lily Thomas

                    </h4>

                    <p className="text-[#666] mt-2">

                      M.A., B.Ed.

                    </p>

                  </div>

                </div>

                {/* PRESIDENT */}
                <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-[#e8e8e8] text-center">

                  <div className="bg-[#0A3470] py-4">

                    <h3 className="text-2xl font-bold text-white">

                      President

                    </h3>

                  </div>

                  <img
                    src={presidentImg}
                    alt="President"
                    className="w-full h-[320px] object-cover"
                  />

                  <div className="p-5">

                    <h4 className="text-xl font-bold text-[#0A3470]">

                      O.A. Joseph

                    </h4>

                  </div>

                </div>

                {/* MANAGER */}
                <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-[#e8e8e8] text-center">

                  <div className="bg-[#0A3470] py-4">

                    <h3 className="text-2xl font-bold text-white">

                      Manager

                    </h3>

                  </div>

                  <img
                    src={managerImg}
                    alt="Manager"
                    className="w-full h-[320px] object-cover"
                  />

                  <div className="p-5">

                    <h4 className="text-xl font-bold text-[#0A3470]">

                      C.J. Thomas

                    </h4>

                  </div>

                </div>

              </div>

            </div>

            {/* CONTACT */}
            <div className="mt-20 bg-[#0A3470] rounded-3xl p-10 text-center">

              <h2 className="text-3xl font-bold text-white">

                Contact Information

              </h2>

              <div className="w-24 h-1 bg-[#D4A017] mx-auto rounded-full mt-4 mb-8"></div>

              <div className="space-y-4 text-lg">

                <p className="text-white">

                  Website:
                  <span className="text-[#D4A017] font-semibold ml-2">

                    stjosephschool.edu.in

                  </span>

                </p>

                <p className="text-white">

                  Email:
                  <span className="text-[#D4A017] font-semibold ml-2">

                    sjsmrj@yahoo.com

                  </span>

                </p>

              </div>

            </div>

          </div>

        </div>

      </section>

      <Footer />
    </>
  );
};

export default Archive;